<template>
<div class="flex-container" id="contact">

    <div id="generalEnquiryContainer" class="flex-item col-12 flex-container" >
      <h3></h3>

      <form id="form" class="flex-item col-12 margin-0" v-on:submit.prevent="submit">
        <div class="flex-item col-12">
          <i class="required">{{translations.allfeilds1}} <span>*</span> {{translations.allfeilds2}}</i>
        </div>

        <div class="flex-item col-12">
          <label for="email">{{translations.email}} <span>*</span></label>
          <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder">
          <small class="form-text text-muted">{{translations.neverShare}} <a v-if="this.$router.currentRoute.query.lang == 'pl' " href="https://www.regatta.pl/polityka-prywatnosci/" target="_blank">{{translations.neverShareLink}}</a> </small>
        </div>

        <div class="flex-item col-12">
          <label for="fullName">{{translations.fullName}} <span>*</span></label>
          <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder">
        </div>


        <div class="flex-item col-12">
          <label for="dateOfPurchase">{{translations.dateofpurchase}} <span>*</span></label>
          <small class="form-text text-muted" style="margin-top:0px;">Format: DD/MM/YYYY</small>
          <input v-model="dateOfPurchase" type="date" placeholder="DD/MM/YYYY" required class="form-control" id="dateOfPurchase" :min='dataMin' :max="dataMax" pattern="(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)">
        </div>

        <div class="flex-item col-12">
          <label for="orderNumber">{{translations.ordernumber}} <span>*</span></label>
          <input v-model="orderNumber" type="number" required class="form-control" id="orderNumber" placeholder="21686939">
          <small class="form-text text-muted">{{translations.ordernumberhelp}}</small>
        </div>

        <div class="flex-item col-12">
          <label for="comment">
            <div v-if="state === 'generalEnquiry' || state === 'delivery'">{{translations.message}} <span>*</span></div>
          </label>
          <textarea v-model="comment" type="text" required class="form-control" id="comment" :placeholder="translations.message"></textarea>
        </div>

        <div class="flex-item col-12 flex-container" v-if="successMessage === 'yes' " id="successMessage" @click="closeSuccessMessage()">
          <h2>{{translations.thankyou}}</h2>
          <div>{{translations.successmessage1}} {{translations.successmessage2}}</div>
        </div>

        <button type="submit" class="btn btn-primary">

          <div class="spinner-border" role="status" v-if="sendState === 'sending'">
            <span class="sr-only">{{translations.sending}} </span>
          </div>

          <div v-if="sendState != 'sending'">{{translations.submit}}</div>

        </button>
      </form>
    </div>

</div>
</template>

<script>
const axios = require('axios');
import jsonFile from './translations.json'

export default {
  name: 'app',
  mounted: function() {
    this.onPageLoad()
  },
  data() {
    return {
      newItem: '',
      state: 'generalEnquiry',
      brand: null,
      brandURL: null,
      newItemPurchase: '',
      statePurchase: 'default',
      faultyItemValue: 'default',
      sendState: 'default',
      fullName: null,
      email: null,
      postCode: null,
      orderNumber: null,
      productSKU: null,
      comment: null,
      enquiryOption: 'delivery-issue',
      storeLocation: null,
      dateOfPurchase: null,
      purchaseOptions: '',
      isItFaulty: null,
      token: 0,
      attachmentQty: null,
      successMessage: null,
      translations: "",
      dataMin: null,
      dataMax: null
    }
  },
  methods: {
    changeState: function(newState) {
      this.state = newState;
      setTimeout(() => {
        // setTimeout to put this into event queue
        if(this.state == "generalEnquiry" || this.state == "delivery"){
          document.getElementById("enquiryOptionsContainer").scrollIntoView({behavior: "smooth", block: "start"});
        }

        if(this.state == "return"){
          document.getElementById("wherePurchase").scrollIntoView({behavior: "smooth", block: "end"});
        }

      }, 0)

    },
    onPageLoad: function() {
      document.getElementsByTagName( 'html' )[0].setAttribute("data-brand", this.$router.currentRoute.params.pathMatch);
      document.getElementsByTagName( 'html' )[0].setAttribute("data-lang", this.$router.currentRoute.query.lang);
      this.dataMin = this.$router.currentRoute.query.dataMin
      this.dataMax = this.$router.currentRoute.query.dataMax

        console.log(this.$router.currentRoute)

      this.brand =  this.$router.currentRoute.params.pathMatch

      var key = this.$router.currentRoute.query.lang
      var translationsUK = jsonFile.uk
      var translationsFR = jsonFile.fr
      var translationsDE = jsonFile.de
      var translationsPL = jsonFile.pl

      if (key == "uk") {
        this.translations = translationsUK
      }
      if (key == "us") {
        this.translations = translationsUK
      }
      if (key == "eu") {
        this.translations = translationsUK
      }
      if (key == "ie") {
        this.translations = translationsUK
      }
      if (key == "fr") {
        this.translations = translationsFR
      }
      if (key == "de") {
        this.translations = translationsDE
      }
      if (key == "pl") {
        this.translations = translationsPL
      }
      //Bit of a daft way of loading these site variants up. Will fix later.
      //Regatta brands
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "uk") {
        this.brandURL =  "https://www.regatta.com/delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "eu") {
        this.brandURL =  "https://www.regatta.com/row/delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "ie") {
        this.brandURL =  "delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "de") {
        this.brandURL =  "https://www.regatta.com/de/ruecksendungen/"
      }

      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "fr") {
        this.brandURL =  "https://www.regatta.com/fr/livraison-retours/#returns"
      }

      if (this.$router.currentRoute.params.pathMatch == "regatta" && this.$router.currentRoute.query.lang == "pl") {
        this.brandURL =  "https://www.regatta.pl/dostawa-i-zwroty/"
      }

      //Dare2b brands
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "uk") {
        this.brandURL =  "https://www.dare2b.com/delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "eu") {
        this.brandURL =  "https://www.dare2b.com/row/delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "ie") {
        this.brandURL =  "https://www.dare2b.ie/delivery-and-returns/#returns"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "de") {
        this.brandURL =  "https://www.dare2b.com/de/ruecksendungen/"
      }
      if (this.$router.currentRoute.params.pathMatch == "dare2b" && this.$router.currentRoute.query.lang == "fr") {
        this.brandURL =  "https://www.dare2b.com/fr/livraison-retours/#returns"
      }

      //Outdoor sports outlet
      if (this.$router.currentRoute.params.pathMatch == "outdoorsportsoutlet" && this.$router.currentRoute.query.lang == "de") {
        this.brandURL =  "https://www.outdoorsportsoutlet.de/ruecksendungen/"
      }

      //Tactical Threads
      if (this.$router.currentRoute.params.pathMatch == "tacticalthreads" && this.$router.currentRoute.query.lang == "uk") {
        this.brandURL =  "https://www.tacticalthreads.co.uk/returns/"
      }

      //Craghoppers
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "uk") {
        this.brandURL =  "https://www.craghoppers.com/returns/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "de") {
        this.brandURL =  "https://www.craghoppers.de/rucksendung/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "us") {
        this.brandURL =  "https://www.craghoppers.com/us/returns/"
      }
      if (this.$router.currentRoute.params.pathMatch == "craghoppers" && this.$router.currentRoute.query.lang == "eu") {
        this.brandURL =  "https://www.craghoppers.com/eu/returns/"
      }

      //Hawkshead
      if (this.$router.currentRoute.params.pathMatch == "hawkshead" && this.$router.currentRoute.query.lang == "uk") {
        this.brandURL =  "https://www.hawkshead.com/delivery-and-returns/#returns"
      }




    },
    closeSuccessMessage: function() {
      this.successMessage = null
    },
    submit: function() {
      this.sendState = 'sending';

      var params = {
        "request": {
          "subject": "Delivery Issue",
          "comment": {
            "body": this.comment,
          },

          "custom_fields": [{
              "id": "360007768460",
              "value": this.orderNumber
            },
            {
              "id": "360007784519",
              "value": this.purchaseOptions + " " +  this.enquiryOption
            },
            {
              "id": "360007768420",
              "value": this.fullName
            },
            {
              "id": "360007768860",
              "value": this.storeLocation
            },
            {
              "id": "360007784039",
              "value": this.productSKU
            },
            {
              "id": "360008703600",
              "value": this.postCode
            },
            {
              "id": "360008715199",
              "value": this.dateOfPurchase
            }
          ],
          "tags": [
            this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang,
            "DeliveryIssue"
          ],

          "requester": {
            "email": this.email,
            "role": "end-user",
            "name": this.fullName
          },
        }
      }


      if(this.attachmentQty >= 1 ){
        var formData = document.querySelector( '#images' ).files[0]
        var formDataName = document.querySelector( '#images' ).files[0].name

        axios.post('https://regatta.zendesk.com/api/v2/uploads.json?filename=' + formDataName, formData, {
          headers: {
              'Content-Type': 'application/binary'
          }
        }).then(resp => {
          this.token = resp.data.upload.token
          console.log(this.token)
          params.request.comment.uploads = this.token;

          console.log(params)
          axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
            this.fullName = this.email = this.postCode = this.orderNumber  = this.productSKU = this.comment = "";
            document.getElementById('images').value = "";
            console.log(resp.status);
            this.attachmentQty = "0"
            this.sendState = '';
            this.successMessage = "yes"

          }).catch(error => {
            console.log(error)
          });

        }).then(function(){
          console.log("message sent")
        }).catch(error => {
          console.log(error)
        });

      } else if(this.attachmentQty <= 0 ){

        console.log(params)
        axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
          this.fullName = this.email = this.postCode = this.orderNumber  = this.productSKU = this.comment = "";
          console.log(resp.status);
          this.sendState = '';
          this.successMessage = "yes"

        }).catch(error => {
          console.log(error)
        });
      }


    }
  }
}

setInterval(function() {
  window.top.postMessage(document.body.scrollHeight, "*");
}, 150);
</script>
